import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=f5e65fce&scoped=true&"
import script from "./ProfileUser.vue?vue&type=script&lang=js&"
export * from "./ProfileUser.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUser.vue?vue&type=style&index=0&id=f5e65fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e65fce",
  null
  
)

export default component.exports